import type {PageRouteConfig} from '@router';

import OrderDetails from 'modules/Orders/OrderDetails/OrderDetails';

export function createOrderDetailsRoute(): PageRouteConfig {
  return {
    element: <OrderDetails />,
    layout: {
      title: 'جزئیات سفارش',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
